import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

import { ROUTES } from 'consts';
import { UnauthLayout } from 'layouts';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';
import { isAllowedRedirectUri } from 'utils/auth-redirect.util';

export const UnauthNavigator = () => {
  const { orgSlug, isLoggedIn } = useAppSelector(selectCurrentUserInfo);
  const navigate = useNavigate();
  const location = useLocation();

  const redirectUri = new URLSearchParams(location.search).get('redirect_uri');
  const { from } = location.state
    ? (location.state as { from: string })
    : { from: `/${ROUTES.ORG_SLUG.replace(':orgSlug', orgSlug)}` };

  useEffect(() => {
    if (isLoggedIn) {
      if (redirectUri && isAllowedRedirectUri(redirectUri)) {
        window.location.href = redirectUri;
      } else {
        navigate(from);
      }
    }
  }, [isLoggedIn, navigate, from, redirectUri]);

  return (
    <UnauthLayout>
      <Outlet />
    </UnauthLayout>
  );
};
